<div>
  <p>Screen Width: {{ screenWidth }} px</p>
  <p>Screen Height: {{ screenHeight }} px</p>
</div>

<!-- Or using the custom function in your template -->
<div></div>
